import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { questService } from '@/services/quest';

export function useQuestBoostList() {
    const useCrudAction = useCrudActions();

    const { list, total, fetchList } = useBaseListView({ request: questService.boost.list });

    const actions = {
        disable: useCrudAction.confirmAndDisable({
            request: questService.boost.disable,
            onSuccess: () => fetchList()
        }),
        enable: useCrudAction.confirmAndEnable({
            request: questService.boost.enable,
            onSuccess: () => fetchList()
        }),
        remove: useCrudAction.confirmAndRemove({
            request: questService.boost.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
